"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorageState = void 0;
const react_1 = __importDefault(require("react"));
const is_defined_1 = require("../is-defined");
const useLocalStorageState = (key, serializer, defaultV) => {
    const [value, setValue] = react_1.default.useState(serializer(window.localStorage.getItem(key)) ?? defaultV);
    react_1.default.useEffect(() => {
        const event = (e) => {
            if (e.storageArea === localStorage) {
                if (e.key === key) {
                    const newV = serializer(e.newValue);
                    if ((0, is_defined_1.isDefined)(newV)) {
                        setValue(() => newV);
                    }
                }
            }
        };
        window.addEventListener('storage', event);
        return () => {
            window.removeEventListener('storage', event);
        };
    }, [setValue]);
    const reducer = (newValue) => {
        window.localStorage.setItem(key, JSON.stringify(newValue));
        window.dispatchEvent(new StorageEvent('storage', { key, newValue: JSON.stringify(newValue), storageArea: localStorage }));
    };
    return { value, reducer };
};
exports.useLocalStorageState = useLocalStorageState;
